'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseLoader = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseLoader, _Component);

  function EnterpriseLoader() {
    (0, _classCallCheck3.default)(this, EnterpriseLoader);
    return (0, _possibleConstructorReturn3.default)(this, (EnterpriseLoader.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseLoader)).apply(this, arguments));
  }

  (0, _createClass3.default)(EnterpriseLoader, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var styles = require('./EnterpriseLoader.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, styles.root) },
        _react2.default.createElement(
          'div',
          { className: styles.wrapper },
          _react2.default.createElement('span', { className: styles.point }),
          _react2.default.createElement('span', { className: styles.point }),
          _react2.default.createElement('span', { className: styles.point }),
          _react2.default.createElement('span', { className: styles.point }),
          _react2.default.createElement('span', { className: styles.point })
        )
      );
    }
  }]);
  return EnterpriseLoader;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string
}, _temp);
exports.default = EnterpriseLoader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseLoader/EnterpriseLoader.jsx
// module id = 1599
// module chunks = 0